import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { fetchNewsletterPosts } from '../../actions/newsletterActions';
import { searchForAllCountriesStaticProps } from '../../actions/searchActions';
import ArticlesPage from '../../page-components/articles';
import type { Article } from '../../types/article';
import type { PaginatedResponse } from '../../types/common';
import type { DataWorldChartTypes } from '../../types/types';

export type ArticlesProps = {
  countries: DataWorldChartTypes[];
  articles: PaginatedResponse<Article[]> | null;
  mainArticle: Article | null;
};

export default function NewsletterPage(props: ArticlesProps) {
  return <ArticlesPage {...props} />;
}

export const getServerSideProps: GetServerSideProps<ArticlesProps> = async (
  context
) => {
  if (!context.query.page) {
    return {
      redirect: {
        destination: `${context.resolvedUrl}?page=1`,
        permanent: false,
      },
    };
  }

  const countries = await searchForAllCountriesStaticProps();

  if (!countries) {
    throw new Error('Error fetching blog posts or countries');
  }

  const articles = await fetchNewsletterPosts({
    page: Number(context.query.page),
    size: 12,
  });

  const mainArticleResponse = await fetchNewsletterPosts({
    page: 1,
    size: 1,
    isMain: true,
  });

  console.log({ mainArticleResponse });
  return {
    props: {
      ...(await serverSideTranslations('en', [
        'common',
        'about',
        'partners',
        'navbar',
        'new-homepage',
        'new-navbar',
        'new-footer',
        'blog',
      ])),
      articles: articles ?? null,
      mainArticle: mainArticleResponse?.data[0] ?? null,
      countries: countries,
    },
  };
};
